// extracted by mini-css-extract-plugin
export default {"TwoDimsFeature":"vz_a bhj_b bhj_wb"};